// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"13":"fe9a56a2","78":"0c56412d","338":"f65dc853","544":"6399cd40","576":"74739b7e","753":"27002556","775":"255e50f5","788":"cb92a752","823":"ac68c450","868":"58e7df0f","990":"e8d4da52"}[chunkId] + ".js";
};